// 로그인 첫 화면 — 구글 로그인. 실패하면 이유를 사장님·기사님 말로 알려 준다(카카오톡 안 브라우저에서 특히 자주 막힌다)
import { useState } from "react";
import { useAuth } from "@/store/auth";

function reasonOf(e: unknown): string {
  const code = (e as { code?: string })?.code || "";
  if (code === "auth/popup-closed-by-user" || code === "auth/cancelled-popup-request") return "로그인 창이 닫혔습니다. 다시 눌러 주세요.";
  if (code === "auth/popup-blocked" || code === "auth/operation-not-supported-in-this-environment" || code === "auth/web-storage-unsupported") {
    return "이 화면에서는 구글 로그인이 막혀 있습니다. 카카오톡으로 여셨다면 오른쪽 위 ⋮(점 세 개) → '다른 브라우저로 열기'를 누른 뒤 다시 로그인해 주세요.";
  }
  if (code === "auth/network-request-failed") return "인터넷 연결이 불안정합니다. 잠시 뒤 다시 눌러 주세요.";
  return "로그인하지 못했습니다. 카카오톡으로 여셨다면 '다른 브라우저로 열기' 뒤 다시 시도해 주세요.";
}

export default function LoginGate() {
  const { signIn } = useAuth();
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const go = async () => {
    setErr("");
    setBusy(true);
    try {
      await signIn();
    } catch (e) {
      setErr(reasonOf(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-milk-50 px-4">
      <div className="card p-8 w-full max-w-md text-center">
        <div className="text-5xl mb-2" aria-hidden="true">🥛</div>
        <h1 className="text-2xl font-extrabold text-milk-800 mb-1">무상우유콕</h1>
        <p className="text-sm text-slate-500 mb-6">무상우유 가정배송 관리 · 사장님·기사님 로그인</p>
        <button className="btn-primary w-full min-h-[48px] text-base" onClick={go} disabled={busy}>
          {busy ? "로그인 창 여는 중…" : "구글 계정으로 로그인"}
        </button>
        {err && <p className="mt-4 text-sm text-rose-600 text-left" role="alert">{err}</p>}
        <p className="mt-4 text-sm text-slate-500 text-left">
          처음이신가요? 사장님은 로그인 뒤 <b>업체 만들기</b>로 시작하고, 기사님은 사장님께 받은 <b>초대 링크</b>로 들어오세요.
          비밀번호는 따로 없고 구글 계정으로만 들어옵니다.
        </p>
        <a className="mt-3 inline-block text-sm underline text-slate-500" href="tel:01026085099">도움이 필요하면 010-2608-5099 (평일 9시~18시)</a>
      </div>
    </div>
  );
}
